import { render, staticRenderFns } from "./exRecord.vue?vue&type=template&id=3f985262&scoped=true&"
import script from "./exRecord.vue?vue&type=script&lang=js&"
export * from "./exRecord.vue?vue&type=script&lang=js&"
import style0 from "./exRecord.vue?vue&type=style&index=0&id=3f985262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f985262",
  null
  
)

export default component.exports